import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BiPermissionService } from '@selfai-platform/bi-domain';
import { BiPermission } from '@selfai-platform/shared';

import { UserService } from '../../user/service/user.service';

@Injectable()
export class DatasourceManagementGuard {
  constructor(private readonly userService: UserService, private readonly permissionService: BiPermissionService) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve, reject) => {
      this.userService
        .isLoggedIn()
        .then((loggedIn) => {
          const canActivate = loggedIn && this.permissionService.hasPermission(BiPermission.KD_DATASOURCE_VIEW_ALL);
          resolve(canActivate);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
